import axios from 'axios';
import config from "../config";

const { api } = config;

const promedicoAxios = axios.create({
  baseURL: api.API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

promedicoAxios.interceptors.request.use(
  (config) => {
    const authUser = sessionStorage.getItem("authUser");
    if (authUser) {
      const user = JSON.parse(authUser);
      if (user && user.token) {
        config.headers.Authorization = `Bearer ${user.token}`;
      }
    }

    // Extract tenant subdomain from hostname and send as header
    const hostname = window.location.hostname;
    const parts = hostname.split('.');
    if (parts.length >= 2) {
      const subdomain = parts[0].toLowerCase();
      if (subdomain !== 'www' && subdomain !== 'api' && subdomain !== 'admin' && subdomain !== 'localhost') {
        config.headers['X-Tenant-Subdomain'] = subdomain;
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

promedicoAxios.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    let message;
    if (error.response) {
      switch (error.response.status) {
        case 500:
          message = "Internal Server Error";
          break;
        case 401:
          // Extract the error message from the response
          message = error.response.data?.message || error.response.data?.detail || error.response.data?.title || "Unauthorized";

          // Only redirect to login if already authenticated (has token in session)
          // Don't redirect if this is a login attempt failure
          const authUser = sessionStorage.getItem("authUser");
          const isLoginAttempt = error.config?.url?.includes('/api/auth/login') || error.config?.url?.includes('/api/auth/google');

          if (authUser && !isLoginAttempt) {
            sessionStorage.removeItem("authUser");
            window.location.href = "/login";
          }
          break;
        case 404:
          message = "Sorry! The data you are looking for could not be found";
          break;
        case 422:
          const validationErrors = error.response.data?.errors;
          if (validationErrors) {
            const errorMessages = Object.values(validationErrors)
              .flat()
              .join(", ");
            message = errorMessages;
          } else {
            message = error.response.data?.title || "Validation error";
          }
          break;
        default:
          message = error.response.data?.message || error.response.data?.detail || error.message || error;
      }
    } else {
      message = "Network error. Please check your connection.";
    }

    // Return the full error object with the message
    return Promise.reject({ message, response: error.response, status: error.response?.status });
  }
);

export const postLogin = async (data: { email: string; password: string }) => {
  return promedicoAxios.post('/api/auth/login', data);
};

export const postRegister = async (data: { name: string; email: string; password: string }) => {
  return promedicoAxios.post('/api/auth/register', data);
};

export const postGoogleLogin = async (data: { googleId: string; email: string; name: string; avatarUrl?: string }) => {
  return promedicoAxios.post('/api/auth/google', data);
};

export const getCurrentUser = async () => {
  return promedicoAxios.get('/api/auth/me');
};

export const setAuthorizationToken = (token: string) => {
  promedicoAxios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
};
